import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';

// Cópia de src/components/Guest — só troca o destino de quem já está
// autenticado, pra mandar de volta pra main do minipay em vez da do app principal.
const MinipayGuest = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/minipay/main" />;
  }

  return <>{children}</>;
};

MinipayGuest.propTypes = {
  children: PropTypes.node
};

export default MinipayGuest;
